<template>
  <main>
    <slot />
  </main>
</template>

<style scoped>
@reference "#tailwind";

main {
  @apply pb-8;
  min-height: calc(100vh - 80px);
}
</style>
